import React from "react";
import OrderTable from "@commons/orders/Table";

const OrderList = ({ state }: { state: any }) => {
  return (
    <div style={{ padding: "20px 0" }}>
      <OrderTable
        type="All"
        initialFilters={
          {
            deliveryBoyId: state.id,
          } as any
        }
      />
    </div>
  );
};

export default OrderList;
